(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-account-portal"] && !Shopify.designMode) return;
  try {
    
  const portal = document.querySelector('[data-customer-portal]');

  if (portal) {
    const orderSelect = portal.querySelector('[data-warranty-order-select]');
    const productSelect = portal.querySelector('[data-warranty-product-select]');
    const productOptions = productSelect ? Array.from(productSelect.options) : [];

    const filterProducts = () => {
      const selected = orderSelect.selectedOptions[0];
      const orderId = selected ? selected.dataset.orderId : '';

      productOptions.forEach((option) => {
        const shouldShow = !option.dataset.orderId || option.dataset.orderId === orderId;
        option.hidden = !shouldShow;
      });

      productSelect.value = '';
    };

    if (orderSelect && productSelect) {
      orderSelect.addEventListener('change', filterProducts);
      filterProducts();
    }

    portal.querySelectorAll('[data-warranty-order]').forEach((button) => {
      button.addEventListener('click', () => {
        const orderId = button.dataset.warrantyOrder;

        if (orderSelect) {
          Array.from(orderSelect.options).forEach((option) => {
            option.selected = option.dataset.orderId === orderId;
          });
          orderSelect.dispatchEvent(new Event('change'));
        }

        const warranty = document.getElementById('warranty');
        if (warranty) {
          warranty.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroes = document.querySelectorAll('[data-nexus-hero-slider]');

    heroes.forEach((hero) => {
      const slides = Array.from(hero.querySelectorAll('[data-nexus-hero-slide]'));
      const dotsContainer = hero.querySelector('[data-nexus-hero-dots]');
      const autoplay = hero.dataset.autoplay === 'true';
      const delay = Number(hero.dataset.delay) || 6000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let timer;

      if (slides.length < 2) {
        dotsContainer?.remove();
        return;
      }

      const dots = slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'nexus-hero__dot';
        dot.setAttribute('aria-label', `Show promotion ${index + 1}`);
        dot.addEventListener('click', () => showSlide(index, true));
        dotsContainer.append(dot);
        return dot;
      });

      function showSlide(index, userInitiated = false) {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === activeIndex);
          dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
        });

        if (userInitiated) restart();
      }

      function start() {
        if (!autoplay || reduceMotion) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1), delay);
      }

      function stop() {
        window.clearInterval(timer);
      }

      function restart() {
        stop();
        start();
      }

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);

      showSlide(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
